module.exports = __webpack_public_path__ + "img/1587452370.82af236d.jpg";